module.exports = __webpack_public_path__ + "img/logo-login.ce74691c.png";